"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_ATTR_NAME = exports.AaCalendarUtilities = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _format = _interopRequireDefault(require("date-fns/format"));

var MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;
var INPUT_ATTR_NAME = {
  FROM: 'checkinDate',
  TO: 'checkoutDate'
};
exports.INPUT_ATTR_NAME = INPUT_ATTR_NAME;
var dateFormat;
var currencyFormat;

var log10 = function log10(n) {
  return Math.round(100 * Math.log(n) / Math.log(10)) / 100;
};

var AaCalendarUtilities = {
  setDateFormat: function setDateFormat(format) {
    dateFormat = format;
  },
  setCurrencyFormat: function setCurrencyFormat(format) {
    currencyFormat = format;
  },
  addMonthToDate: function addMonthToDate(date, toAdd) {
    if (!date || !toAdd) {
      return;
    }

    return new Date(date.getFullYear(), date.getMonth() + toAdd, 1);
  },
  addDaysToDate: function addDaysToDate(date, toAdd) {
    if (!date || !toAdd) {
      return;
    }

    return new Date(new Date(date).setDate(date.getDate() + toAdd));
  },
  subtractDaysToDate: function subtractDaysToDate(date, toSubtract) {
    if (!date || !toSubtract) {
      return;
    }

    return new Date(new Date(date).setDate(date.getDate() - toSubtract));
  },
  subtractMonthToDate: function subtractMonthToDate(date, toSubtract) {
    if (!date || !toSubtract) {
      return;
    }

    return new Date(new Date(date).setMonth(date.getMonth() - toSubtract));
  },
  checkIfDateAreSame: function checkIfDateAreSame(date1, date2) {
    if (!date1 || !date2) {
      return;
    }

    return date1.setHours(0, 0, 0, 0) === date2.setHours(0, 0, 0, 0);
  },
  checkIfDateIsAheadOfStartDate: function checkIfDateIsAheadOfStartDate(checkDate, startDate) {
    if (!checkDate || !startDate) {
      return;
    }

    return checkDate.setHours(0, 0, 0, 0) >= startDate.setHours(0, 0, 0, 0);
  },
  checkIfDateIsPreviousOfStartDate: function checkIfDateIsPreviousOfStartDate(checkDate, startDate) {
    if (!checkDate || !startDate) {
      return;
    }

    return checkDate.setHours(0, 0, 0, 0) < startDate.setHours(0, 0, 0, 0);
  },
  checkIfDateIsPreviousOrEqualOfStartDate: function checkIfDateIsPreviousOrEqualOfStartDate(checkDate, startDate) {
    if (!checkDate || !startDate) {
      return;
    }

    return checkDate.setHours(0, 0, 0, 0) <= startDate.setHours(0, 0, 0, 0);
  },
  yearsDifference: function yearsDifference(d1, d2) {
    if (!d1 || !d2) {
      return;
    }

    var date1 = new Date(d1);
    var date2 = new Date(d2);
    var yearsDiff = date2.getFullYear() - date1.getFullYear();
    return yearsDiff;
  },
  monthsDifference: function monthsDifference(d1, d2) {
    if (!d1 || !d2) {
      return;
    }

    var date1 = new Date(d1);
    var date2 = new Date(d2);
    var years = AaCalendarUtilities.yearsDifference(d1, d2);
    var months = years * 12 + (date2.getMonth() - date1.getMonth());
    return months;
  },
  dayDifference: function dayDifference(date1, date2) {
    if (!date1 || !date2) {
      return;
    }

    var timeDiff = date2.getTime() - date1.getTime();
    var diffDays = Math.ceil(timeDiff / MILLISECONDS_PER_DAY);
    return diffDays;
  },
  daysAfterToday: function daysAfterToday(date) {
    var today = new Date();
    return AaCalendarUtilities.dayDifference(today, date);
  },
  formatDates: function formatDates(d) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dd/MM/yyyy';

    if (!d) {
      return '';
    }

    if (!Boolean(Date.parse(d))) {
      return null;
    }

    var newFormat = format.replace(new RegExp("m", "g"), "M");
    return (0, _format["default"])(d, newFormat); // let {month, date, finalMonth}  = '';
    // finalMonth = d.getMonth() + 1;
    // date = d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`;
    // month = finalMonth > 9 ? finalMonth : `0${finalMonth}`;
    // console.log(format);
    // return `${date}/${month}/${d.getFullYear()}`
  },
  setNoDayFormat: function setNoDayFormat(date) {
    if (!date) {
      return;
    }

    if (!dateFormat || !dateFormat.date) {
      return;
    }

    if (dateFormat.date.noDay !== 'mmm yyyy') {
      return AaCalendarUtilities.formatDates(date, dateFormat.date.noDay);
    }

    var dateArray = AaCalendarUtilities.formatDates(date, dateFormat.date.noDay).split(" ");
    dateArray[0] = dateFormat.shortMonthTranslation[dateArray[0].toLowerCase()];
    var newDate = dateArray.join(" ");
    return newDate;
  },
  datePayloadFormat: function datePayloadFormat(d) {
    if (!d) {
      return '';
    }

    var _ref = '',
        month = _ref.month,
        date = _ref.date,
        finalMonth = _ref.finalMonth;
    finalMonth = d.getMonth() + 1;
    date = d.getDate() > 9 ? d.getDate() : "0".concat(d.getDate());
    month = finalMonth > 9 ? finalMonth : "0".concat(finalMonth);
    return "".concat(d.getFullYear(), "-").concat(month, "-").concat(date);
  },
  mccConverter: function mccConverter(value, rate) {
    if (value === undefined || value === null) {
      return;
    }

    if (rate != undefined) {
      return value * rate;
    }

    return value;
  },
  isValueThousands: function isValueThousands(value) {
    return log10(value) >= 3 && log10(value) < 6;
  },
  isValueMillions: function isValueMillions(value) {
    return log10(value) >= 6;
  },
  currencySymbolFormatter: function currencySymbolFormatter(value, currency) {
    if (value === undefined || value === null) {
      return;
    }

    if (Number.isNaN(value)) {
      return;
    }

    if (value === 0 || value === ' ' || value === '') {
      return;
    }

    if (!currency) {
      return;
    }

    if (!currency.collectedCurrency) {
      return;
    }

    if (!currencyFormat) {
      return;
    } // if(!currencyFormat[currency.collectedCurrency.toUpperCase()]){
    //     return ' ';
    // }
    // return value;


    var currencyData = currencyFormat[currency.collectedCurrency.toUpperCase()];
    var currencySymbol = currencyData ? currencyData.shortSymbol : '';
    var decimalThousand = currencyData ? currencyData.shortDecimalThousand || 0 : 1;
    var decimalMillion = currencyData ? currencyData.shortDecimalMillion || 0 : 2;
    var price = value;
    var abbreviationSymbol = '';
    var formattedPrice = '';

    if (AaCalendarUtilities.isValueThousands(price)) {
      var p = price / 1e3;
      price = AaCalendarUtilities.currencyFormatter(p, decimalThousand);
      abbreviationSymbol = currencyFormat.abbreviation.thousand;
    } else if (AaCalendarUtilities.isValueMillions(price)) {
      var _p = price / 1e6;

      price = AaCalendarUtilities.currencyFormatter(_p, decimalMillion);
      abbreviationSymbol = currencyFormat.abbreviation.million;
    } else {
      price = AaCalendarUtilities.currencyFormatter(price, 0);
    }

    if (currencyData && currencyData.shortFormat) {
      formattedPrice = currencyData.shortFormat.replace(/s/g, currencySymbol).replace(/v/g, price);
    } else {
      formattedPrice = "".concat(currencySymbol).concat(price);
    }

    formattedPrice = "".concat(formattedPrice).concat(abbreviationSymbol);
    return formattedPrice;
  },
  exchangeRateConverter: function exchangeRateConverter(value, exchangeRate) {
    if (value === undefined || value === null) {
      return;
    }

    value *= exchangeRate;
    return value; // value = Math.floor(value);
    // // let isThousands = log10(value) >= 3;
    // // let isMillion = log10(value) >= 6;
    // if(AaCalendarUtilities.isValueThousands(value)){
    //     let p = value/ 1e3;
    //     console.log(p)
    //     // let price = AaCalendarUtilities.currencyFormatter(p, currencyData.shortDecimalThousand);
    //     // let formattedPrice = `${currencyData.shortSymbol}${price}`
    //     return p;
    // }
    // if(AaCalendarUtilities.isValueMillions(value)){
    //     let p = value / 1e6;
    //     // let price = AaCalendarUtilities.currencyFormatter(p, currencyData.shortDecimalMillion);
    //     // let formattedPrice = `${currencyData.shortSymbol}${price}`
    //     return p;
    // }
    // let price =  AaCalendarUtilities.currencyFormatter(value, 0);
    // // let formattedPrice = `${currencyData.shortSymbol}${price}`;
    // return price
  },
  toFixed: function toFixed(num, fixed) {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
  },
  currencyFormatter: function currencyFormatter(value, decimal) {
    if (value === undefined || value === null) {
      return;
    }

    var currencyDecimal = 2; //default to 2.

    if (decimal != undefined || decimal != null) {
      currencyDecimal = decimal;
    } // let formatedCurrency = Number(parseFloat(value).toFixed(currencyDecimal));


    var formatedCurrency = Number(AaCalendarUtilities.toFixed(parseFloat(value), currencyDecimal));

    if (Number.isNaN(formatedCurrency)) {
      return ' ';
    }

    ;
    return formatedCurrency;
  },
  formatDateInputFormat: function formatDateInputFormat(value) {
    var strArray = value.split(/[^0-9]/);

    var _strArray = (0, _slicedToArray2["default"])(strArray, 3),
        date = _strArray[0],
        month = _strArray[1],
        year = _strArray[2];

    var formattedDate = "".concat(month, "/").concat(date, "/").concat(year);

    if (!Boolean(Date.parse(formattedDate))) {
      return null;
    }

    return formattedDate;
  },
  createDateFromString: function createDateFromString(stringDate) {
    var defaultDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

    if (!stringDate) {
      return defaultDate;
    }

    return new Date(stringDate);
  }
};
exports.AaCalendarUtilities = AaCalendarUtilities;